import React from "react";
import { LegalNotice } from "@outpave/ds";
import { useTranslation } from "react-i18next";
import { useBrandingContext } from "context/BrandingContext";

/** Where the documents live when a white-label host has not supplied its own. */
const OUTPAVE_TERMS = "https://www.outpave.com/terms-and-conditions";
const OUTPAVE_PLATFORM_AGREEMENT = "https://www.outpave.com/platform-agreement";
const OUTPAVE_PRIVACY = "https://www.outpave.com/privacy-and-security";

/**
 * The fine print under a transfer's confirmation.
 *
 * The package's `LegalNotice` owns the type treatment, the link styling and the
 * list joining, which is what this stopped hand-rolling: three raw anchors
 * carrying `text-primaryDark font-semibold` (a legacy light-pinned variable)
 * inside one `Trans` string with the commas baked into the copy, so a locale
 * could not punctuate the list its own way.
 *
 * The branded pair is deliberate. A white-label host's admins have to reach
 * THEIR policies, not ours, and losing a branding field in a component merge is
 * a mistake this migration has already made twice.
 */
const TransferTermsAndConditions: React.FC = () => {
  const { t } = useTranslation();
  const { platform } = useBrandingContext();

  return (
    <LegalNotice
      align="start"
      prefix={t("TransferTermsPrefix")}
      links={[
        {
          label: t("company terms"),
          href: platform?.termsUrl || OUTPAVE_TERMS,
        },
        {
          label: t("service agreements"),
          href: platform?.termsUrl || OUTPAVE_PLATFORM_AGREEMENT,
        },
        {
          label: t("privacy policies"),
          href: platform?.privacyUrl || OUTPAVE_PRIVACY,
        },
      ]}
      suffix={t("TransferTermsSuffix")}
      conjunction={t("and")}
      oxfordComma
    />
  );
};

export default TransferTermsAndConditions;
